import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TFunction } from 'i18next';
import { IChip } from 'app/ComponentLibrary/Filter/ChipsContainer';
import { SortColumn } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { initialCandidateSkillSetFilter } from 'app/ComponentLibrary/Filter/CandidateSkillset';

export interface IOrderCandidateMatch {
  count: number;
  items: any[];
  filters: IOrderCandidateMatchFilters;
  filterSpecs: IFilterspecs;
  payload: any;
  chips: IOrderCandidateMatchChips;
  appliedFilters?: any | null;
}
export interface IOrderCandidateMatchFilters {
  divisionOpts: any[];
  specialityOpts: any[];
  availableStartDate: any;
  activePlacementOpts: any | null;
}

export interface IFilterspecs {
  disciplineOpts: any[];
  specialityOpts: any[];
}

export interface IOrderCandidateMatchChips {
  recruiterIds: IChip[] | any[];
  recruitingSpecialistIds: IChip[] | any[];
  candidateFilter: any | null;
  skillsetFilter: any | null;
  candidateIds: IChip[] | [];
  cIds: IChip[] | [];
  brandIds: IChip[] | any[];
  candidateStatusIds: IChip[] | any;
  disciplineIds: IChip[] | [];
  specialtyIds: IChip[] | [];
  availableStartDate: any | null;
  lastApplicationDateRange: any | null;
  nonContactedDate: any | null;
  callBackDateRange: any | null;
  LastPlacementEndDateRange: any | null;
  states: IChip[] | [];
  city: IChip[] | [];
  zipCode: any | null;
  radius: any | null;
  virtualInterview: any | null;
  covidVaxStatus: IChip[] | [];
  license: any | null;
  certification: any | null;
  workHistory: any | null;
  activePlacements: any | null;
  skillsetFilter: any | null;
}

export const defaultFilterSpecs: IFilterspecs = {
  disciplineOpts: [],
  specialityOpts: [],
};

export const defaultFilterState: IOrderCandidateMatchFilters = {
  divisionOpts: [],
  specialityOpts: [],
  availableStartDate: null,
  activePlacementOpts: [],
};

const defaultPayload = {
  divisionId: [],
  skillSets: [],
};

export const defaultChips: IOrderCandidateMatchChips = {
  recruiterIds: [],
  recruitingSpecialistIds: [],
  candidateFilter: [],
  skillsetFilter: initialCandidateSkillSetFilter,
  candidateIds: [],
  cIds: [],
  brandIds: [],
  candidateStatusIds: [],
  disciplineIds: [],
  specialtyIds: [],
  availableStartDate: null,
  lastApplicationDateRange: null,
  nonContactedDate: null,
  callBackDateRange: null,
  LastPlacementEndDateRange: null,
  states: [],
  city: [],
  zipCode: null,
  radius: null,
  virtualInterview: null,
  covidVaxStatus: [],
  license: null,
  certification: null,
  workHistory: null,
  activePlacements: null,
};
export const initialState: IOrderCandidateMatch = {
  count: 0,
  items: [],
  filters: defaultFilterState,
  filterSpecs: defaultFilterSpecs,
  payload: defaultPayload,
  chips: defaultChips,
  appliedFilters: null,
};

const getOrderCandidateMatchAction = createAction<{
  filter?: any;
  pageNumber: number;
  pageSize: number;
  keyword?: string;
  skillset: string[];
  divisionId?: string[];
  activePlacements?: any;
  orderStartDate?: any;
  translation: TFunction;
  sortedColumn?: any;
  multiSortedColumns?: SortColumn[];
  recruiterIds?: [];
  candidateIds?: [];
  candidateFilter?: any;
  skillsetFilter?: any;
  cIds?: [];
  brandIds?: [];
  skillsetFilter?: any;
  candidateStatusIds?: [];
  disciplineIds?: string[];
  specialtyIds?: string[];
  lastApplicationDateRange?: any;
  nonContactedDate?: any;
  callBackDateRange?: any;
  LastPlacementEndDateRange?: any;
  states?: [];
  city?: [];
  zipCode?: string;
  radius?: any;
  virtualInterview?: any;
  license?: any;
  certification?: any;
  workHistory?: any;
}>('GET_ORDER_CANDIDATEMATCH');

const reduxSlice = createSlice({
  name: 'orderCandidateMatch',
  initialState,
  reducers: {
    setData(state, action: PayloadAction<{ count: number; items: any[] }>) {
      state.items = action.payload.items;
      state.count = action.payload.count;
    },
    setFilters(state, action: PayloadAction<any>) {
      state.filters = action.payload;
    },
    setFilterSpecs(state, action: PayloadAction<{ disciplineOpts: any[]; specialityOpts: any[] }>) {
      state.filterSpecs.disciplineOpts = action.payload.disciplineOpts;
      state.filterSpecs.specialityOpts = action.payload.specialityOpts;
    },
    setPayload(state, action: PayloadAction<any>) {
      state.payload = action.payload;
    },
    setSelectedFilters(state, action: PayloadAction<any>) {
      state.appliedFilters = action.payload;
    },
    setChips(state, action: PayloadAction<any>) {
      state.chips = action.payload;
    },
    reset() {
      return { ...initialState };
    },
  },
});

export const getOrderCandidateMatchActions = { ...reduxSlice.actions, getOrderCandidateMatchAction };
export const { name: orderCandidateMatchSliceKey, reducer: orderCandidateMatchReducer } = reduxSlice;
